import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const HelmetSEO = ({
  contentfulApplication,
  description,
  meta,
  title,
  applicationName,
}) => {
  const metaDescription = description || contentfulApplication.description

  return (
    <Helmet
      title={title}
      titleTemplate={`%s | ${contentfulApplication.metaTitle}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: contentfulApplication.twitterUsername,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

HelmetSEO.defaultProps = {
  meta: [],
  description: ``,
}

HelmetSEO.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  contentfulApplication: PropTypes.object.isRequired,
}

export default HelmetSEO
